import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { appConfig } from '@app/app.config';
import { loadRuntimeConfig, renderRuntimeConfigError } from '@shared/runtime-config';

loadRuntimeConfig()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => {
    console.error('Runtime config load failed', err);
    renderRuntimeConfigError(err);
  });
